import { useMemo } from 'react';

interface GenerateDataOptions {
  startDate?: string;
  endDate?: string;
  minDataRange?: number;
  maxDataRange?: number;
  numberOfPoints?: number;
}

export type ArrayDataPoint = [string, number];

// todo: move to utils
export const generateMockDataPoints = ({
  startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10),
  endDate = new Date().toISOString().slice(0, 10),
  minDataRange = 0,
  maxDataRange = 50000,
  numberOfPoints = 500,
}: GenerateDataOptions): ArrayDataPoint[] => {
  const startMillis = new Date(`${startDate}T00:00Z`).getTime();
  const endMillis = new Date(`${endDate}T23:59Z`).getTime();
  const totalMillis = endMillis - startMillis;
  const stepMillis = totalMillis / numberOfPoints;

  const data: ArrayDataPoint[] = [];

  for (let i = 0; i < numberOfPoints; i += 1) {
    const timestamp = new Date(startMillis + i * stepMillis).toISOString();
    const count = Math.floor(minDataRange + Math.random() * (maxDataRange - minDataRange + 1));
    data.push([timestamp, count]);
  }

  return data;
};

export const useGeneratedMockDataPoints = (options: GenerateDataOptions): ArrayDataPoint[] => {
  return useMemo(() => generateMockDataPoints(options), [options]);
};
